import {ShoppingList} from "../Modules/ShoppingList";
import * as querystring from "querystring";

/**
 * Voucher
 */
export class Voucher {
    protected wrapper: HTMLElement;
    protected voucherInput: HTMLInputElement;
    protected submitButton: HTMLButtonElement;
    protected errorTextElement: HTMLElement|undefined;
    protected successTextElement: HTMLElement|undefined;

    constructor(wrapper: HTMLElement, voucherInput: HTMLInputElement, submitButton: HTMLButtonElement) {
        this.wrapper = wrapper;
        this.voucherInput = voucherInput;
        this.submitButton = submitButton;
        this.errorTextElement = wrapper.querySelector('.voucher-error');
        this.successTextElement = wrapper.querySelector('.voucher-success');

        this.submitButton.addEventListener('click', this.submitVoucher, {passive: true});
        this.voucherInput.addEventListener('keyup', this.inputProcessor, {passive: true});

        this.disableButton(true);
    }

    /**
     * Submit the voucher and update the layout
     */
    protected submitVoucher = () => {
        this.resetErrorState();

        this.voucherRequest()
        .then((data) => {
            if (!data.success) {
                this.wrapper.classList.add('has-error');

                if (this.errorTextElement) {
                    this.errorTextElement.classList.remove('d-none');
                    this.errorTextElement.innerHTML = data.error;
                }

                this.disableButton(true)

                return;
            }

            const list = ShoppingList.getShoppingList(this.wrapper);
            const summary = ShoppingList.getListSummaryElement(list);
            const url = list.dataset.summaryUrl;

            if (url) {
                this.summaryRequest(url)
                    .then((html) => {
                        summary.innerHTML = html;
                    });
            }

            if (this.successTextElement) {
                this.successTextElement.classList.remove('d-none');
                this.successTextElement.innerHTML = data.message;
            }

            this.disableButton(false)
        });
    }

    /**
     * Send request to voucher api and return the response as json
     */
    protected voucherRequest = async () => {
        const url = new URL(globalUrls.voucherLink, window.location.origin);
        url.searchParams.set('code', this.voucherInput.value);

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.json();
    }

    /**
     * Get the summary
     *
     * @param url
     */
    protected summaryRequest = async (url: string) => {
        const response = await fetch(url, {
            method: 'GET',
        });

        return response.text();
    }

    /**
     * Process the input
     *
     * @param e
     */
    protected inputProcessor = (e: KeyboardEvent) => {
        this.disableButton(!this.isValueValid())

        if (e.key === 'Enter' && this.isValueValid()) {
            this.submitVoucher();
        }
    }

    /**
     * Check if the value is valid
     */
    protected isValueValid = (): boolean => {
        return (this.voucherInput.value && this.voucherInput.value.length > 0);
    }

    /**
     * Reset the error state
     */
    protected resetErrorState = () => {
        this.wrapper.classList.remove('has-error');
        this.errorTextElement.classList.add('d-none');
        this.successTextElement.classList.add('d-none');
    }

    /**
     * Disable the button
     *
     * @param disable
     */
    protected disableButton = (disable: boolean) => {
        if (disable) {
            this.submitButton.disabled = true;
            this.submitButton.classList.add('disabled');
        } else {
            this.submitButton.disabled = false;
            this.submitButton.classList.remove('disabled');
        }
    }

    /**
     * create instances
     *
     * @param elementList
     */
    static createInstances = (elementList:NodeListOf<HTMLElement>) => {
        Array.from(elementList).forEach((el) => {
            new Voucher(
                el,
                el.querySelector('input'),
                el.querySelector('button')
            );
        });
    }
}

/**
 * Initialize voucher
 */
export function initVoucher() {
    const vouchers: NodeListOf<HTMLElement> = document.querySelectorAll('.voucher-form');
    Voucher.createInstances(vouchers);
}
